import { ProductBase } from "../../shared-gen/Model/Products/ProductBase";
import { Product } from "../../shared-gen/Model/Products/Product";
import { DeviceStatus } from "../../shared-gen/Device/Status/DeviceStatus";
import { DeviceStatusFun } from "../../shared/device/device-status.fun";
import { Theme } from "./themes/theme";
import { noTheme } from "./themes/theme.fun";
import { Door } from "../../shared-gen/Model/Devices/Door";
import { DoorState } from "../../shared-gen/Model/Devices/DoorState";
import { DynamicSettings } from "./settings";
import { DynamicSettingsFun } from "./settings.fun";
import { Currency } from "../../shared-gen/Model/Utils/Currency";
import { Selections } from "../../shared-gen/Model/Selections/Selections";
import { Menu } from "../../shared-gen/Model/Menus/Menu";
import { MenuFun } from "../../shared/model/menus/menu.fun";
import { SelectionsFun } from "../../shared/model/selections/selections.fun";

/**
 * Status of the app.
 * It contains the current theme, the menu, the VMC status and some
 * client side state.
 */
export interface AppStatus {
	/** Current status of the device, including all modules, menu, pricelist and more. */
	deviceStatus: DeviceStatus;
	/** The current menu, as given by the device */
	menuOriginal: Menu;
	/** The current menu, updated by the app (e.g. auto-generated start page) */
	menu: Menu;
	/** The current selections */
	selections: Selections;
	/** The current theme. */
	theme: Theme;
	/** Currently selected button for requesting the product
	 * or showing product options. */
	selectedProduct: ProductBase | Product;
	/** The current settings. */
	settings: DynamicSettings;
}

/**
 * Returns an app status to begin with.
 * Can be used before the app is fully initialized.
 */
export function emptyAppStatus(): AppStatus {
	return {
		deviceStatus: DeviceStatusFun.offline(),
		menuOriginal: MenuFun.createNew(''),
		menu: MenuFun.createNew(''),
		selections: SelectionsFun.createNew(''),
		theme: noTheme,
		selectedProduct: null,
		settings: DynamicSettingsFun.createNew()
	};
}

export function getCurrency(appStatus: AppStatus): Currency {
	try {
		return appStatus.deviceStatus.VendingStatus.Currency;
	} catch {
		return Currency.EUR;
	}
}

export type DoorStates = { [key in Door]?: DoorState };
